<template>
    <div>
        <iframe v-if="show" style="width: 100%; height: 100vh;border:none;" :src="iframe"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframe: '',
            show:false
        }
    },
    mounted() {
        const payurl = this.$route.query.payurl;
       

        if (this.isNotWeibo()) {
            // 若非微博内嵌，使用固定 iframe 地址
            this.show=false;
            
            window.location.href = payurl;
        } else {
            // 否则使用传入 payurl
            this.show=true;
            this.iframe = payurl ;
            //window.location.href = payurl;
        }
    },
    methods: {
        isNotWeibo() {
            const ua = navigator.userAgent.toLowerCase();
            return !/weibo|__weibo__/.test(ua);
        }
    }
}
</script>
